// Require

const { id, log, min, max, limit } = require("../std/index")


//
// Fancy Title
//
// Knows how to dodge around slices on the homepage
//

module.exports = class FancyTitleWidget {
  constructor($host, config) {
    this.titleSpaceLarge = 230;
    this.titleSpaceSmall = 125;

    this.logoWidthLarge = 360;
    this.logoWidthMed = 260;
    this.logoWidthSmall = 170;

    this.dimmedOpacity = 0.1;

    this.dom = {
      main: $host,
      logo: $('.site-logo', $host)
    };

    this.tween = this.generateTween();
    this.tween.seek(0);
  }

  generateTween() {
    const tween = new TimelineMax({ paused: true });
    tween.to(this.dom.logo, 1, { width: logoWidthMed }, 0);
    tween.to(this.dom.logo, 1, { width: logoWidthSmall }, 1);
    //tween.to(this.dom.logo, 1, { alpha: dimmedOpacity }, 1);
    tween.to(this.dom.logo, 1, { alpha: 1 }, 2);
    tween.fromTo(this.dom.main, 1, { height: titleSpaceLarge }, { height: titleSpaceSmall }, 2);
    return tween;
  }

  seek(p) {
    // Single-page mode
    this.dom.main.toggleClass('shrink', p > 0);

    // Scroll-locked mode
    // this.tween.seek(p);
  }
};
